import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgSettings from '../../svg/settings.svg'
import { IconProps } from '../icon-props'

const SettingsIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgSettings
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-settings', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default SettingsIcon
